import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import { I18NextNS } from 'src/models/Language.model';

import useCancelCaptureImages from 'src/hooks/camera/useCancelCaptureImages';
import { useContinueCaptureProcess } from 'src/hooks/camera/useContinueCaptureProcess';
import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';

const SmallPupilModal = () => {
  const { t } = useTranslation(I18NextNS.PAGES);

  const { isCanceling, cameraConnectionIssueReason } = useRemoteBoundStore();

  const { handleCancelCapture } = useCancelCaptureImages();

  const { continueCaptureProcess } = useContinueCaptureProcess();

  const handleContinueCaptureProcess = () => {
    continueCaptureProcess();
  };

  const { currentCaptureProcess } = useGetCurrentCaptureProcess();

  // TODO: contact with MediWork to test the small pupil feature
  const handleExit = async () => {
    handleCancelCapture();
  };

  return (
    <CustomModal
      show={currentCaptureProcess?.isPupilSmall && !cameraConnectionIssueReason}
    >
      <Modal.Header>
        <Modal.Title>{t('newExam.smallPupil.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('newExam.smallPupil.desc')}</Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary-100"
          className="text-primary"
          onClick={handleContinueCaptureProcess}
          disabled={isCanceling}
          data-track="exam.small-pupil-modal.continue"
          data-observe
        >
          {t('newExam.smallPupil.continue')}
        </Button>
        <Button
          variant="primary"
          onClick={handleExit}
          disabled={isCanceling}
          data-track="exam.small-pupil-modal.cancel-imaging"
          data-observe
        >
          {isCanceling
            ? t('newExam.cancelingImaging')
            : t('newExam.cancelImaging')}
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
};

export default SmallPupilModal;
